import { Label } from "@outschool/ui-legacy-component-library";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

function makeUnreadCountLabel(n: Number, max = 99) {
  if (typeof n !== "number") {
    return "0";
  }
  return n > max ? `${max}+` : `${n}`;
}

export default function UnreadMessagesCount({
  count,
  color = "#929eaa",
  sx = {}
}: {
  count?: Number;
  color?: string;
  sx?: SystemStyleObject;
}) {
  const finalValue = makeUnreadCountLabel(count);
  if (finalValue === "0") {
    return null;
  }

  return (
    <Label
      data-test-id="unread-message-count"
      color={color}
      sx={{
        marginLeft: "0.25em",
        paddingX: "0.25em",
        paddingY: 0,
        borderRadius: "2em",
        ...sx
      }}
    >
      {finalValue}
    </Label>
  );
}
